import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const words = ['Experiment', 'Innovate', 'Create'];

const gradientStyles = [
    {
        background: 'linear-gradient(95deg, #E5FFF3 12.67%, #0BFD93 121.85%)',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
    },
    {
        background: 'linear-gradient(95deg, #E5FFF3 12.67%, #FDDE6E 121.85%)',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
    },
    {
        background: 'linear-gradient(90deg, #FFF 41.61%, #28C1F9 77.6%)',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
    },
];

const WordRotate = () => {
    const [index, setIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((prev) => (prev + 1) % words.length);
        }, 2000); // Rotate every 2 seconds
        return () => clearInterval(interval);
    }, []);

    return (
            <AnimatePresence mode="wait">
                <motion.div
                    key={words[index]}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.3 }}
                >
                    <p
                       style={{
                            textAlign: 'center',
                            fontFamily: 'Plus Jakarta Sans',
                            fontWeight: '800',
                            letterSpacing: '-2.282px',
                            fontSize: '68px',
                            ...gradientStyles[index],
                        }}
                    >
                        {words[index]}
                    </p>
                </motion.div>
            </AnimatePresence>
    );
};

export default WordRotate;
